import React from 'react'
import {
  Dialog,
  DialogContent,
  Typography,
  Link,
  Box,
  Grid,
} from '@material-ui/core'

import categories from '../../constants/categories'
import useStyles from './styles'

const EnterDialog = ({ post, enter, handleCloseEnter, roomCategory }) => {
  const classes = useStyles()

  return (
    <Dialog open={enter} onClose={handleCloseEnter} className={classes.dialog}>
      <DialogContent className={classes.content}>
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          justifyContent={'center'}
          minHeight={360}
          color={'common.white'}
          textAlign={'center'}
        >
          {categories.map((category) =>
            roomCategory === category.name ? (
              <Grid key={category._id}>
                <Typography variant='h4' className={classes.title}>
                  {category.title}
                </Typography>
                <Typography variant='h6' className={classes.subtitle}>
                  <strong>Instruction:</strong>{' '}
                  <em>
                    Keep cameras and sound on or off is up to you. Please report
                    to us if there is any violations, sensitive video, abusive
                    or harmful via (admin@oyeeah.com).
                  </em>{' '}
                  Thank You & {category.subtitle}
                </Typography>
              </Grid>
            ) : null
          )}

          <Typography variant='body2' className={classes.clickLink}>
            Click the link below to join the room
          </Typography>
          <Link
            href={post.roomLink}
            target='_blank'
            rel='noreferrer'
            color='inherit'
            underline='none'
          >
            {categories.map((category) =>
              roomCategory === category.name ? (
                <Typography key={category._id} className={classes.enterButton}>
                  Take me to the {category.sticker}
                  {category.name} room
                </Typography>
              ) : null
            )}
          </Link>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default EnterDialog
